'use client'
 
import { useReportWebVitals } from 'next/web-vitals'
import { sendGAEvent } from '@next/third-parties/google'
 
type ReportWebVitalsCallback = Parameters<typeof useReportWebVitals>[0]
 
const handleWebVitals: ReportWebVitalsCallback = (metric) => {
  sendGAEvent(metric.name, {
    event_label: metric.id,
    non_interaction: true,
    value: metric.value.toString(),
  })
}
 
export function WebVitals() {
  useReportWebVitals(handleWebVitals)
  return null
}